__turbopack_context__.v({
  "headerLine": "SeriesCard-module__-vK7hG__headerLine",
  "insight": "SeriesCard-module__-vK7hG__insight",
  "titleLink": "SeriesCard-module__-vK7hG__titleLink",
});
